import { createAction } from '@reduxjs/toolkit';

export const changeAddFormValue = createAction('changeAddFormValue');

export const handleAddCardHolderFormChange = (name, value) => dispatch =>
    dispatch(changeAddFormValue({ name, value }));
